// HRMS shared API client.
import axios from 'axios';
const BASE = `${process.env.REACT_APP_BACKEND_URL}/api/hrms`;
const ax = axios.create({ baseURL: BASE, withCredentials: true });
ax.interceptors.request.use((cfg) => {
  const t = localStorage.getItem('bsc_token');
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  const cid = localStorage.getItem('hrms_company_id');
  if (cid) cfg.headers['X-Company-Id'] = cid;
  return cfg;
});
export const hr = {
  get: (p, params) => ax.get(p, { params }).then((r) => r.data),
  post: (p, body) => ax.post(p, body).then((r) => r.data),
  put: (p, body) => ax.put(p, body).then((r) => r.data),
  del: (p) => ax.delete(p).then((r) => r.data),
};
export default hr;
